// import { split } from 'apollo-link';
// import { getMainDefinition } from 'apollo-utilities';
// import { HttpLink } from 'apollo-link-http';
// import { WebSocketLink } from 'apollo-link-ws';
// import { setContext } from 'apollo-link-context';
// const {
//   REACT_APP_API,
//   REACT_APP_API_SECURE,
//   REACT_APP_WS_ENABLED
// } = process.env;

import { SchemaLink } from 'apollo-link-schema';
const { schema } = require('../../mocks/schema');

export default class Config {
  // getWSConfig = () => {
  //   const wsEnabled = JSON.parse(REACT_APP_WS_ENABLED);
  //   return new WebSocketLink({
  //     uri: `wss://${REACT_APP_API}/graphql`,
  //     options: {
  //       reconnect: wsEnabled
  //     }
  //   });
  // };

  // getHTTPConfig = () => {
  //   return new HttpLink({
  //     uri: `${this.getHTTPHost()}/graphql`,
  //     credentials: 'same-origin'
  //   });
  // };

  getHTTPHost = () => {
    //   const protocol = JSON.parse(REACT_APP_API_SECURE) ? 'https' : 'http';
    //   return `${protocol}://${REACT_APP_API}`;
    return 'https://example.com';
  };

  getAuthHeader = () => {
    //   const token = localStorage.getItem('access_token');
    //   // return the headers to the context so httpLink can read them
    //   return {
    //     authorization: token ? `Bearer ${token}` : ''
    //   };
    return {};
  };

  // getAuthConfig = () =>
  //   setContext((_, { headers }) => {
  //     // get the authentication token from local storage if it exists
  //     return {
  //       headers: {
  //         ...headers,
  //         ...this.getAuthHeader()
  //       }
  //     };
  //   });

  getConfig = () => {
    // const link = split(
    //   ({ query }) => {
    //     const { kind, operation } = getMainDefinition(query);
    //     return kind === 'OperationDefinition' && operation === 'subscription';
    //   },
    //   this.getWSConfig(),
    //   this.getHTTPConfig()
    // );
    // const authConfig = this.getAuthConfig();
    // return authConfig.concat(link);

    return new SchemaLink({ schema });
  };
}
